import {action} from "mobx";
import operationOrganizationService from "../services/operationOrganizationService";
import userService from "../services/userService";
import appStore from "./appStore";
import i18n from "../i18n";

class OperationOrganizationStore {
    // Zone Management Actions
    @action getZoneManagementList = async (params = {}) => {
        try {
            const response = await operationOrganizationService.getZoneManagementList(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Bölge müdürlükleri listesi yüklenirken hata oluştu."
            });
            return false;
        }
    };

    @action getZoneManagementById = async params => {
        try {
            const response = await operationOrganizationService.getZoneManagementById(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Bölge müdürlüğü bilgileri yüklenirken hata oluştu."
            });
            return false;
        }
    };

    @action createZoneManagement = async params => {
        try {
            const response = await operationOrganizationService.createZoneManagement(params);
            if (response.status !== 201) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge müdürlüğü başarıyla oluşturuldu."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge müdürlüğü oluşturulurken hata oluştu."});
            return false;
        }
    };

    @action updateZoneManagement = async params => {
        try {
            const response = await operationOrganizationService.updateZoneManagement(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge müdürlüğü başarıyla güncellendi."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge müdürlüğü güncellenirken hata oluştu."});
            return false;
        }
    };

    @action deleteZoneManagement = async params => {
        try {
            const response = await operationOrganizationService.deleteZoneManagement(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge müdürlüğü başarıyla silindi."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge müdürlüğü silinirken hata oluştu."});
            return false;
        }
    };

    @action restoreZoneManagement = async params => {
        try {
            const response = await operationOrganizationService.restoreZoneManagement(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge müdürlüğü başarıyla geri yüklendi."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge müdürlüğü geri yüklenirken hata oluştu."});
            return false;
        }
    };

    // Zone Actions
    @action getZoneList = async (params = {}) => {
        try {
            const response = await operationOrganizationService.getZoneList(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Bölgeler listesi yüklenirken hata oluştu."
            });
            return false;
        }
    };

    @action getZoneById = async params => {
        try {
            const response = await operationOrganizationService.getZoneById(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Bölge bilgileri yüklenirken hata oluştu."
            });
            return false;
        }
    };

    @action createZone = async params => {
        try {
            const response = await operationOrganizationService.createZone(params);
            if (response.status !== 201) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge başarıyla oluşturuldu."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge oluşturulurken hata oluştu."});
            return false;
        }
    };

    @action updateZone = async params => {
        try {
            const response = await operationOrganizationService.updateZone(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge başarıyla güncellendi."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge güncellenirken hata oluştu."});
            return false;
        }
    };

    @action deleteZone = async params => {
        try {
            const response = await operationOrganizationService.deleteZone(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge başarıyla silindi."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge silinirken hata oluştu."});
            return false;
        }
    };

    @action restoreZone = async params => {
        try {
            const response = await operationOrganizationService.restoreZone(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Bölge başarıyla geri yüklendi."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge geri yüklenirken hata oluştu."});
            return false;
        }
    };

    @action getZonesByZoneManagement = async params => {
        try {
            const response = await operationOrganizationService.getZonesByZoneManagement(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Bölge müdürlüğüne ait bölgeler yüklenirken hata oluştu."
            });
            return false;
        }
    };

    @action getZonesByCity = async params => {
        try {
            const response = await operationOrganizationService.getZonesByCity(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Şehre ait bölgeler yüklenirken hata oluştu."
            });
            return false;
        }
    };

    // Field Manager (Saha Yöneticisi) Actions
    @action getFieldManagerList = async (params = {}) => {
        try {
            const response = await userService.getUserList({
                skip: params.skip || 0,
                limit: params.limit || 1000,
                role: "sy",
                activity: "active",
                searchText: params.searchText || ""
            });
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Saha yöneticileri listesi yüklenirken hata oluştu."
            });
            return false;
        }
    };

    // İK listesi
    @action getIkList = async (params = {}) => {
        try {
            const response = await userService.getUserList({
                skip: params.skip || 0,
                limit: params.limit || 1000,
                role: "ik",
                activity: "active",
                searchText: params.searchText || ""
            });
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "İK listesi yüklenirken hata oluştu."
            });
            return false;
        }
    };

    // Acente listesi
    @action getAgencyList = async (params = {}) => {
        try {
            const response = await userService.getUserList({
                skip: params.skip || 0,
                limit: params.limit || 1000,
                role: "agency",
                activity: "active",
                searchText: params.searchText || ""
            });
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Acente listesi yüklenirken hata oluştu."
            });
            return false;
        }
    };

    // Acente-İK listesi
    @action getAgencyIkList = async (params = {}) => {
        try {
            const response = await userService.getUserList({
                skip: params.skip || 0,
                limit: params.limit || 1000,
                role: "agencyIk",
                activity: "active",
                searchText: params.searchText || ""
            });
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Acente-İK listesi yüklenirken hata oluştu."
            });
            return false;
        }
    };

    @action listZoneSubcompanies = async params => {
        try {
            const response = await operationOrganizationService.listZoneSubcompanies(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge alt firmaları yüklenirken hata oluştu."});
            console.log(error);
            return false;
        }
    };

    @action assignZoneToCourier = async params => {
        try {
            const response = await operationOrganizationService.assignZoneToCourier(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Bölge kuryeye atanırken hata oluştu."});
            return false;
        }
    };
}

export default new OperationOrganizationStore();
